export const form = {
    name: 'Name',
    email: 'E-mail',
    phone: 'Phone',
    state: 'State',
    city: 'City',
    role: 'Your role in the work',
    zipcode: 'Zip code',
    uf: 'UF',
    required: 'Required',
    invalid: 'Invalid',
    newsletter: 'I would like to receive Castelatto news by e-mail',
    button: 'Search Dealers',
    error: 'One or more fields have an error. Please check and try again.',
    request_error: 'Sorry, there was an error with your request. Try again.',
    success: 'Wait. We are doing your research.',
    professional: 'Specifying Professional (Architect, Interior Designer, Landscape Architect, Engineer, etc.)',
    builder: 'Construction company, Developer, Engineering',
    consumer: 'Final costumer',
    others: 'Others',
    call: 'Phone call',
    header: 'Fill out the form and find<br>the Castelatto partner store closest to you.',
    alert: '* All fields are required',
};

export const result = {
    no_results: 'We appreciate your interest in CASTELATTO products. You will receive an e-mail shortly',
    engineering_results: "For personalized assistance, please wait for contact from our Engineering team.",
    title: 'Search Result',
    result: 'Resale near you',
    thanks: 'Thank you for your interest in CASTELATTO products. See below the stores closest to CEP: {zipcode}',
    address: 'Address',
    phone: 'Phone',
    zipcode: 'Zipcode',
    email: 'Email',
    city: 'City',
    distance: 'Distance',
    how_to_get: 'How to get',
    button: 'BACK',
    print: 'Print',
    send: 'Send by email',
    innovation: 'Innovation',
    architecture: 'Architecture',
    design: 'Design',
    success: 'Email successfully sent',
    error: 'There was an error sending your email. :/',
};
